import React, { useState, useEffect } from "react";

import Header from "../common/Header";
import Footer from "../common/Footer";
import PackageContainer from "./package";
import DayPackageContainer from "./dayPackage";
import RotationPackageComp from "./RotationPackage";
import { scrollHandler, goToByScroll } from "../../util/animation";
import { getUserData } from "../../util/util";
import { history } from "../../history/history";

const Package = (props) => {
  //Set the initial state for package
  const [latitude, setLatitude] = useState(undefined);
  const [longitude, setLongitude] = useState(undefined);
  const [station, handleStation] = useState("");
  const [stations, handleStations] = useState([]);
  const [rodp, handleRodp] = useState(undefined);
  const [customRodp, handleCustomRodp] = useState("");
  const [startTime, handleStartTime] = useState("");
  const [endTime, handleEndTime] = useState("");
  const [city, setCity] = useState(undefined);
  const [showPackage, handleShowPackage] = useState(true);
  const [idArr] = useState([
    "package_con",
    "rotation_pack",
    "day_pack",
    "budget_pack",
  ]);
  const [currentId, handleCurrentId] = useState("rotation_pack");
  const [scrollText, handleScrollText] = useState("Scroll for more");
  const [goToTop, handleGoToTop] = useState(true);
  const [stationview, handlestationView] = useState("single");
  const [stationwisedetails, handlestationwisedetails] = useState({});
  const [multistatedetails, handleMultiStateDetails] = useState({});

  //Handle the scroll
  useEffect(() => {
    window.addEventListener("scroll", () => {
      handleGoToTop(false);
      scrollHandler();
      handleScroll();
    });
    getMyLocation();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (goToTop) {
        console.log("It is going to top");
        window.scrollTo(0, 0);
      }
    }, 1000);
  });

  //Fetching the user location
  const getMyLocation = () => {
    const location = navigator && navigator.geolocation;
    if (location && !props.history.location.state) {
      location.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          setLatitude(19.076);
          setLongitude(72.8777);
          setCity("Mumbai");
        }
      );
    } else {
      setLatitude(props.history.location.state.lat);
      setLongitude(props.history.location.state.lon);
      setCity(props.history.location.state.city);
    }
  };

  //Fetching the rodp
  const getRodp = (rodp, customrodp, startTime, endTime, showPackage) => {
    console.log("rrrrroooooo", rodp);
    handleRodp(rodp);
    handleCustomRodp(customrodp);
    handleShowPackage(showPackage);
    handleStartTime(startTime);
    handleEndTime(endTime);
  };

  //Handle station name
  const handleStationName = (stationObj) => {
    handleStation(stationObj.station);
    if (stationObj.lat && stationObj.long) {
      setLatitude(stationObj.lat);
      setLongitude(stationObj.long);
    }
  };

  //Select a package
  const choosePackage = (packageDetails) => {
    let userData = getUserData();
    if (latitude && longitude) {
      packageDetails = { ...packageDetails, lat: latitude, lon: longitude };
    }
    // packageDetails = {...packageDetails, lat: Latitude, lon:longitude }
    if (
      userData &&
      userData.email &&
      (userData.role === "user" ||
        (userData.role === "dsa" &&
          userData.kycstatus &&
          userData.kycstatus.status === "Verified"))
    ) {
      history.push({ pathname: "/campaign", state: { packageDetails } });
    } else if (
      userData && userData.role === "dsa" &&
      (!userData.kycstatus ||
        (userData.kycstatus && userData.kycstatus.status !== "Verified"))
    ) {
      window.location.pathname = "/tp/EditKycDetails";
    } else {
      history.push({ pathname: "/login", state: { packageDetails } });
    }
  };

  //Go to by scroll
  const goToScrollSection = (id) => {
    let index = idArr.indexOf(id);
    if (id == "budget_pack") {
      goToByScroll(id);
      // handleScrollText("Scroll to top");
      handleCurrentId(idArr[0]);
    } else {
      goToByScroll(id);
      // handleScrollText("Scroll for more");
      handleCurrentId(idArr[index + 1]);
    }
  };

  const handleScroll = () => {
    var elmnt = document.getElementById("budget_pack");
    var elmnt2 = document.getElementById("main_wrapper");
    if (
      elmnt &&
      elmnt.scrollHeight + window.scrollY >= elmnt2.offsetHeight - 200
    ) {
      handleScrollText("Scroll to top");
      handleCurrentId(idArr[0]);
    } else {
      handleScrollText("Scroll for more");
    }
  };

  console.log("rodp in parent===___", rodp);
  //Return the packages
  return (
    <div className="main_wrapper" id="main_wrapper">
      <div className="packages_banner" id="package_con">
        <Header />
        <PackageContainer
          handlestationView={handlestationView}
          handleStationName={handleStationName}
          latitude={latitude}
          station={station}
          scrollText={scrollText}
          longitude={longitude}
          city={city}
          getRodp={getRodp}
          choosePackage={choosePackage}
          stations={stations}
          handleStations={handleStations}
          stationwisedetails={stationwisedetails}
          goToScrollSection={goToScrollSection}
          currentId={currentId}
          multistatedetails={multistatedetails}
        />
      </div>
      <div id="rotation_pack">
        <RotationPackageComp
          stationwisedetails={stationwisedetails}
          stationview={stationview}
          rodp={rodp}
          handleMultiStateDetails={handleMultiStateDetails}
          customRodp={customRodp}
          startTime={startTime}
          endTime={endTime}
          station={station}
          showPackage={showPackage}
          choosePackage={choosePackage}
          stations={stations}
          handleStations={handleStations}
          handlestationwisedetails={handlestationwisedetails}
        />
      </div>
      {/* {stationview === 'single' &&
      <div id= "day_pack">
        <DayPackageContainer rodp={rodp} station= {station} customRodp={customRodp} startTime={startTime} endTime={endTime} showPackage={showPackage} choosePackage= {choosePackage} />
      </div>} */}
      <Footer />
    </div>
  );
};
export default Package;



// WEBPACK FOOTER //
// ./web/components/package/index.js